<template>
    <div v-if="!stylesFromParent.minimalInfo" :class="from && from == 'metadataView'?'metadataViewCustomStyles':''" :key="componentKey" style="display:flex;margin: 4px;flex-direction: column;user-select: text !important; 
      cursor:text;">
        <div style="display: flex;padding:5px" class="subclip-top-bar">
            <div v-on:click="playSubclip()" class="subclip-thumbnail" :style="stylesFromParent.image" style="position:relative">
                <div v-if="from && from == 'metadataView'" class="playOverlay">
                    <div class="pbtn" aria-hidden="true">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                        <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="rgba(255,255,255,.92)"/>
                        </svg>
                    </div>
                </div>
                <template v-if="isAudioFile">
                    <img :src="getAudioFileSvg()"  alt="Audio" :style="(isMetadataDock || isTagMetadataDock || isProperitesWindow) ? 'height:52px !important;' : ''" style="width:100%;height: 106px;object-fit:contain;border-radius: 7px;">
                </template>
                <img v-else :src="getProxyConvertedURL(thumbnail)" @error="replaceByDefaultImage" alt="Thumbnail not found" style="width:100%;object-fit:contain;border-radius: 7px;">
                <!-- <svg v-if="thumbnail != defaultThumbnail" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-play-circle-fill play-icon" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>
                </svg> -->
            </div>
            <div class="w-100"  style="display: flex !important;align-items: flex-start;">
                <ul>
                    <li>
                        <!-- <div class="key-style">Subclip</div> -->
                        <div v-if="subclipsData.markers" class="value-style thumbnail-view-duration-label timePill-subclip" style="overflow-wrap:anywhere;text-align:start;width:auto"><div style="color: #319aab;margin-top: 1px;">{{getDurationInSecondsForMarkers(subclipsData.markers.start) + (subclipsData.subclip_type && subclipsData.subclip_type.toLowerCase().includes('image') ? '' : ' - ' + getDurationInSecondsForMarkers(subclipsData.markers.end))}}</div></div>
                        <!-- <div class="value-style slug-name" :style="stylesFromParent.slugFontSize">{{subclipsData.slug_name}}</div> -->
                    </li>
                    <li v-if="subclipsData.asset_modified_datetime">
                        <!-- <div class="key-style">Description</div> -->
                        <div class="value-style" style="font-size: 12px;">
                            {{getDateAndTimeInConfiguredFormat(subclipsData.asset_modified_datetime)}}
                        </div>
                    </li>
                    <li v-else-if="subclipsData.modified_datetime">
                        <div class="value-style" style="font-size: 12px;">
                            {{getDateAndTimeInConfiguredFormat(subclipsData.modified_datetime)}}
                        </div>
                    </li>
                    <!-- <li v-if="('subclip_type' in subclipsData) && (subclipsData.subclip_type == 'smart')" class="notification-filters">
                        {{$t('Smart Subclip')}}
                    </li> -->
                    <component :is="smartSubclipLableComponent" :subclipsData="subclipsData"/>
                </ul>
            </div>
        </div>
        <div class="d-inline-block w-100">
                <ul>
                    <li v-if="subclipsData.slug_name != undefined">
                        <!-- <div class="key-style">Subclip</div> -->
                        <div class="value-style slug-name" :style="stylesFromParent.slugFontSize">{{subclipsData.slug_name}}</div>
                    </li>
                    <li v-if="subclipsData.metadata !=  undefined && subclipsData.metadata.description && subclipsData.metadata.description.length > 0">
                        <!-- <div class="key-style">Description</div> -->
                        <div class="value-style description-field" style="white-space: pre-line;color:#adadad">
                            <div v-if="subText && subclipsData.metadata.description.length > 250">{{subclipsData.metadata.description.substring(0,250)}}...<span @click.stop.prevent="subText = false"><b style="color:#8f8253;cursor: pointer;">See more</b></span></div><div v-else>{{subclipsData.metadata.description}}</div>
                        </div>
                    </li>
                    <li v-if="categoryDetails.length > 0">
                        <!-- <div class="key-style">In</div> -->
                        <div class="value-style catalog-path-display" style="display: flex;flex-direction: column;">
                            <template v-for="(op , index) in categoryDetails" >
                                <span  style="color: #c58f8f" :key="subclipsData.slug_name + op.id">{{"value" in op? op.value.split('catalog://0')[1] :op.parent_path.value.split('catalog://0')[1]}}{{index != categoryDetails.length - 1?',':''}}</span>
                            </template>
                        </div>
                    </li>
                    <li v-if="subclipsData.tag_info !=  undefined && subclipsData.tag_info.length">
                        <!-- <div class="key-style">Tags</div> -->
                        <div class="value-style mb-1"><div v-for="tag in subclipsData.tag_info" :key="tag._id" class="selected-tags-style">
                            {{tag.name}}
                        </div></div>
                    </li>
                    <li v-for="custommetadata in subclipsData.custom_metadata"
                        :key="custommetadata.key_id" class="d-block p-0"
                        >
                        <ul class="m-0">
                            <li class="custom-metadata-rows">
                                <div class="key-style" :style="isMetadataDock?'width:30%':'width:20%'">{{ getCustomMetadataName(custommetadata.key_id) }}</div>
                                <div class="value-style d-inline-flex" style="width:70%">
                                <template v-if="['PICKLIST','PICKLIST_MULTIVALUE'].includes(custommetadata.type)">
                                    <div class="w-100" v-if="custommetadata.value.length">
                                    {{getPicklistValueNames(custommetadata.value)}}
                                    </div>
                                </template>
                                <template v-else-if="['DATE_TIME', 'DATE'].includes(custommetadata.type)">
                                    <div class="w-100" v-if="custommetadata.value.length">
                                    {{getDateAndTimeInConfiguredFormat(custommetadata.value)}}
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="w-100" v-if="custommetadata.value.length">
                                    {{custommetadata.value.join(",")}}
                                    </div>
                                </template>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li v-if="Object.keys(subclipsData).includes('file_info') &&
                    !['undefined',null].includes(subclipsData.file_info) &&  subclipsData.file_info.length > 0" class="transcript-wrapper" style="padding:0px">
                        <div class="text-left actions-on-transcript" style="color: #777;display:inline-flex;">
                            <svg v-if="!showFileInfo" v-on:click.stop.prevent="showFileInfo = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                            </svg>
                            <svg v-else-if="showFileInfo" v-on:click.stop.prevent="showFileInfo = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                            </svg>
                            <span style="position:relative;inset-inline-start:1px;font-size: 16px;top: 2px;">File info</span>
                        </div>
                        <template v-if="showFileInfo">
                            <div style="display:flex;padding-inline-start: 20px;padding-top: 10px;">
                                <div style="width:20%;display: flex;align-items: flex-start;justify-content: center;">
                                    <div v-on:click.stop.prevent="handlePreviewAction(subclipsData)" :style="isMetadataDock?'height: 50px; width: 96px;':'height: 68px; width: 114px;'" style=" position: relative;align-items: center;display: inline-flex;justify-content:center;cursor:pointer;border: 1px solid #3a3a3a;
                                    border-radius: 8px;">
                                        <img :src="getThumbnailPath(subclipsData)" @error="replaceByDefaultImage()" alt="image" draggable="false" style="height:100%;border-radius: 8px;max-width:100%"/>
                                        <div v-if="'mime_type' in subclipsData && (subclipsData.mime_type.startsWith('video') || subclipsData.mime_type.startsWith('audio')) && 'duration' in subclipsData && subclipsData.duration"
                                            class="sub-thumbnail-view-duration-label">
                                            {{getHumanReadableDuration(subclipsData.duration)}}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <li v-if="subclipsData.created_datetime">
                                        <div class="key-style">Created On</div>
                                        <div class="value-style">{{getDateAndTimeInConfiguredFormat(subclipsData.created_datetime)}}</div>
                                    </li>
                                    <li v-if="subclipsData.size">
                                        <div class="key-style">Size</div>
                                        <div class="value-style">{{humaniseSize(subclipsData.size)}} ({{subclipsData.size}} bytes)</div>
                                    </li>
                                    <li :class="isMetadataDock?'adjust-alignments':''">
                                        <template v-if="Object.keys(subclipsData).includes('file_info') &&
                                        !['undefined',null].includes(subclipsData.file_info) &&  subclipsData.file_info.length > 0">
                                            <div class="value-style" style="width:96%">
                                            <div v-for="file in subclipsData.file_info" :key="file" class="wrap-file-info" style="width:100%">
                                                <template>
                                                <div v-if="Object.keys(file).includes('file_name') &&
                                                    !['undefined',null].includes(file.file_name) &&  file.file_name.length > 0" style="display:flex">
                                                    <div class="key-style mr-2">File Name</div>
                                                    <div class="value-style ml-0">{{file.file_name}}</div>
                                                </div>
                                                <div v-if="Object.keys(file).includes('file_path') &&
                                                    !['undefined',null].includes(file.file_path) &&  file.file_path.length > 0" style="display:flex">
                                                    <div class="key-style mr-2">File Path</div>
                                                    <div class="value-style ml-0">{{file.file_path}}</div>
                                                </div>
                                                <div v-if="file.location && file.location.length" style="display:flex">
                                                    <div class="key-style mr-2">Location</div>
                                                    <div class="value-style ml-0">
                                                        <div v-for="storageClass in file.location" class="d-inline-flex" :key="storageClass">
                                                        <svg v-if='storageClass == "Disk"' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16"><path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path><title>Archived</title></svg>
                                                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(subclipsData.location_info,storageClass)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16">
                                                            <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                        </svg>
                                                        <span style="margin-inline-start:4px">{{ storageClass }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                </template>
                                            </div>
                                            </div>
                                        </template>
                                        <template v-else-if="Object.keys(subclipsData).includes('path') &&
                                        !['undefined',null].includes(subclipsData.path) && subclipsData.path.length > 0">
                                            <div class="key-style">Path</div>
                                            <div class="value-style">{{subclipsData.path}}</div>
                                        </template>
                                    </li>
                                </div>
                            </div>
                        </template>
                    </li>
                   <template v-for="list in subclipPluginsList" >
                        <component  :key="list.id" :is="list.component" v-bind="{subclipsData,getDurationFormatAsHHorMMSS, isPrivEnabled, isPluginInstalled, loadTrancsriptEdit, toggleTranscriptPlayMode, playTranscript, viewTranscript, highlightTranscript, disableTranscriptEditMode, from:from && from == 'metadataView'?'metadataView':'subclipRow',comp:()=>{return this;}}"></component>
                    </template> 
                    
                  <!-- <div v-if="isPluginInstalled('Transcript')" class="transcript-wrapper">
                        <div class="text-left actions-on-transcript" style="color: #777;display:inline-flex;margin-top:0px">
                            <svg v-if="!showTranscript" @click.stop.prevent="viewTranscript()" v-on:click="showTranscript = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill icon-background-on-hover" viewBox="0 0 16 16">
                                <path stroke="currentColor" stroke-width="1" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                            </svg>
                            <svg v-else-if="showTranscript" v-on:click.stop.prevent="showTranscript = false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill icon-background-on-hover" viewBox="0 0 16 16">
                                <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                            </svg>
                            <span style="position:relative;inset-inline-start:1px;font-size: 16px;top: 2px;">Transcript</span>
                            <div @click="loadTrancsriptEdit()" style="padding-inline-start: 10px;">
                                <svg v-if="isPrivEnabled('Transcript') && showTranscript" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pen-fill transcript-edit" fill="#9c9c9c" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                                    <title>Edit Transcript</title>
                                </svg>
                            </div>
                        </div>
                        <template v-if="showTranscript">
                        <div class="each-transcript" v-for="transcript in subclipsData.transcript" :key="transcript.uid">
                            <div class="transcript-preview">
                                <div class="transcript-content">
                                    <div class="transcript-play transcript-timestamp">
                                        <div style="display: flex;" class="transcript-play-pause" @click="playTranscript(transcript)">
                                            <svg v-if="toggleTranscriptPlayMode(transcript)" xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
                                                <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
                                            </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#01868c" class="bi bi-play-fill" viewBox="0 0 16 16">
                                                <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                                            </svg>
                                        </div>
                                        <div class="common-media-in-out-display">
                                            <span>{{getDurationFormatAsHHorMMSS(transcript.media_in)}}</span> - <span>{{getDurationFormatAsHHorMMSS(transcript.media_out)}}</span>
                                        </div>
                                    </div>
                                    <div class="transcript-spoken-content" v-html="highlightTranscript(transcript.content)">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="'transcript' in subclipsData && subclipsData.transcript.length <= 0" class="no-data-found">
                            No Transcript yet
                        </div>
                        </template>
                    </div>  -->
                </ul>
        </div>
    </div>
    <div v-else-if="stylesFromParent.minimalInfo" :key="componentKey">
        <div class="subclip-thumbnail d-inline-flex" :style="stylesFromParent.image">
            <div style="position:relative;inset-inline-start:4px;width:10%">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16">
                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                    <title>Subclip</title>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1af3ff" class="bi bi-input-cursor" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :10px;top:3px">
                    <path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>
                    <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>
                    <title>Subclip</title>
                </svg>
            </div>
            <!-- <div style="width:10%">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#c6c6c6" class="bi bi-braces" viewBox="0 0 16 16" style="    position: relative;
    inset-inline-end: 4px;background: #295318;
    border-radius: 6px;padding:2px">
                    <path d="M2.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6zM13.886 7.9v.163c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456V7.332c-1.114 0-1.49-.362-1.49-1.456V4.352C13.51 2.759 12.75 2 11.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6z"/>
                </svg>
            </div> -->
            <div v-on:click="playSubclip()" style="height: 100px;width: 65%;display: inline-block;">
                <img :src="getProxyConvertedURL(thumbnail)" @error="replaceByDefaultImage"  alt="Thumbnail not found" :style="thumbnail == defaultThumbnail?'width:61%':'height:100%'" style="object-fit: contain;width:100%;border-radius: 7px;">
            </div>
        </div>
        <div v-if="subclipsData.slug_name != undefined" style="position: relative;inset-inline-start:18px;top: 2px;">
            <div class="value-style slug-name ml-0" :style="stylesFromParent.slugFontSize" style="width:100%;text-align: start;white-space: nowrap;width: 93%;overflow: hidden;text-overflow: ellipsis;" :title="subclipsData.slug_name">{{subclipsData.slug_name}}</div>
        </div>
        <div v-if="subclipsData.markers !=  undefined" style="position: relative;inset-inline-start:18px;top: 2px;">
            <div class="value-style ml-0" style="overflow-wrap:anywhere"><div :style="stylesFromParent.duration" style="color: #319aab;margin-top: -2px;">{{getDurationInSecondsForMarkers(subclipsData.markers.start) + '-' + getDurationInSecondsForMarkers(subclipsData.markers.end)}}</div></div>
        </div>
    </div>
</template>

<script>
import Utils from "../../components.utils.js" ;
import {NotifierConstants} from "../../components.constants.js";
import {mapActions, mapMutations, mapGetters} from "vuex";

export default {
   name:'SubclipsRows',
   props:['makinmarkout',"subclipsData","customStyles","latestCapturedThumbnail","selectedAssetId","isMetadataDock","isSubclipOnAudio","fileInfo","isTagMetadataDock","isProperitesWindow", "disableTranscriptEditMode",'from'],
   data(){
       return {
           thumbnail:Utils.getNoThumbnailImg(),
           defaultThumbnail:Utils.getNoThumbnailImg(),
           stylesFromParent:{minimalInfo:false},
           customMetadataList:[],
           fieldInfo:[],
           subText:true,
           playingRegionUid:null,
           showTranscript:false,
           showFileInfo:false,
           subclipPluginsList:[],
           smartSubclipLableComponent:null,
           componentKey: 0
       };
   },
   async mounted(){
       if(this.subclipsData.markers != undefined && this.subclipsData.markers.frame_thumbnail_uri != undefined){
           this.thumbnail = Utils.convertToLoginIPDomainName(this.subclipsData.markers.frame_thumbnail_uri);
           if(this.thumbnail.length == 0){
            this.thumbnail = this.defaultThumbnail;
           }
       }else if(this.subclipsData.markers != undefined && this.subclipsData.markers.mime_type != undefined && this.subclipsData.markers.mime_type == 'audio'){
           let svg = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 104.23 122.88" style="fill:#418969;height:90%" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M87.9,78.04c2.74-0.48,5.33-0.4,7.6,0.13V24.82L39.05,41.03v61.95c0.03,0.34,0.05,0.69,0.05,1.03 c0,0,0,0.01,0,0.01c0,8.34-8.75,16.62-19.55,18.49C8.76,124.37,0,119.12,0,110.77c0-8.34,8.76-16.62,19.55-18.48 c4.06-0.7,7.84-0.39,10.97,0.71l0-76.26h0.47L104.04,0v85.92c0.13,0.63,0.2,1.27,0.2,1.91c0,0,0,0,0,0.01 c0,6.97-7.32,13.89-16.33,15.44c-9.02,1.56-16.33-2.83-16.33-9.8C71.57,86.51,78.88,79.59,87.9,78.04L87.9,78.04L87.9,78.04z"/></g></svg>`;
           this.thumbnail = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
       }
       else{
           this.thumbnail = this.defaultThumbnail;
       }
       try{ 
           Utils.loadPluginBundles([{id:'smartsubclip_bundle_js',jsUrl:`${window.location.origin}/damplugins/ai_prompts/web/smartsubclip_bundle.js`}],'smartsubclip-component-loaded').then(async(ev)=>{
            let event;
            event = ev;
           console.log('event smartsubclip-component-loaded',event);
           if(event && Array.isArray(event) && !event[0]){
              await new Promise(r => setTimeout(r, 2000));
              event = await Utils.loadPluginBundles([{id:'smartsubclip_bundle_js',jsUrl:`${window.location.origin}/damplugins/ai_prompts/web/smartsubclip_bundle.js`}],'smartsubclip-component-loaded');
           }
            if(event && Array.isArray(event) && event.length){
                if(event[0].components['SmartSubclipLableComponent']){
                  const ev = new Event('register-routes');
                  if(Object.prototype.hasOwnProperty.call(event[0] , 'pluginStore'))
                    ev.pluginStore = event[0].pluginStore;
                  parent.document.body.dispatchEvent(ev);
                  Utils.loadCssBundle({id:'smartsubclip_bundle_css',cssUrl:`${window.location.origin}/damplugins/ai_prompts/web/smartsubclip_bundle.css`});
                  this.smartSubclipLableComponent = event[0].components['SmartSubclipLableComponent'];
                }
              }
          });
        }catch(e){console.log(e)}
        for(let i = 0; i < this.getSubclipPlugins.length; i++){
            console.log("this.getSubclipPlugins[i] SUBCLIP ROW", this.getSubclipPlugins[i], this.getSubclipPlugins[i].evalCondition(this))
            if(this.getSubclipPlugins[i].evalCondition(this)){
                let compInfo;
                 compInfo = await  Utils.loadPluginBundles([this.getSubclipPlugins[i].pluginBundle.js],this.getSubclipPlugins[i].componentLoadedEventName);
                if(compInfo && Array.isArray(compInfo) && !compInfo[0]){
                     await new Promise(r => setTimeout(r, 2000));
                     compInfo = await  Utils.loadPluginBundles([this.getSubclipPlugins[i].pluginBundle.js],this.getSubclipPlugins[i].componentLoadedEventName);
                }
                if(compInfo && Array.isArray(compInfo) && compInfo[0] && compInfo.length){
                    if('register' in this.getSubclipPlugins[i]){
                        this.getSubclipPlugins[i].register();
                    }
                    Utils.loadCssBundle(this.getSubclipPlugins[i].pluginBundle.css);
                    this.subclipPluginsList.push({id:this.getSubclipPlugins[i].id,component:compInfo[0].components});
                }
            }
        }
   },
   computed:{
    categoryDetails(){
        let tempArr = [];
        if (Object.keys(this.subclipsData).includes("catalog_path")){
            if(this.subclipsData.catalog_path.length > 0){
            tempArr = this.subclipsData.catalog_path
        }
        }else if (Object.keys(this.subclipsData).includes("parent_path")){
            if(this.subclipsData.parent_path.length > 0){
            tempArr = this.subclipsData.parent_path
        }
        } 
        if(tempArr.length > 0){
            tempArr = tempArr.filter(e => e._id != "0")
        } 
        return tempArr;
    },
    isAudioFile(){
        if(this.fileInfo){
            return Utils.getFileMediaType(this.fileInfo) == 'audio'
        }
        if(this.isSubclipOnAudio != undefined || this.isSubclipOnAudio != null){
             return this.isSubclipOnAudio;
        }
        return false;
    },
    ...mapGetters("users",["getLoggedInUserPrivilege"]),
    ...mapGetters('pluginRepo',["getInstalledPluginsData"]),
    ...mapGetters("registry",["getSubclipPlugins"]),
   },
   methods:{
    getAudioFileSvg(){
        return Utils.getAudioWaveformSvg();
    },
    handlePreviewAction(fileinfo){
        this.$emit("previewProxy",fileinfo)
    },
    getColorBasedOnExpiry(locationInfo,storage){
        return Utils.getAWSStorageIconColorBasedOnExpiry(locationInfo,storage)
    },
    isPluginInstalled(pluginName){
        if(this.getInstalledPluginsData){
            let indx = this.getInstalledPluginsData.findIndex(e => e.plugin_name.toLowerCase() == pluginName.toLowerCase())
            if(indx > -1){
                return true;
            }
        }
        return false;
    },
    viewTranscript(){
        this.$emit("viewTrancsript",this.subclipsData);
    },
    isPrivEnabled(privId){
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, privId);
    },
    loadTrancsriptEdit(){
        this.$emit("editSubclipTranscript", this.subclipsData);
    },
    toggleTranscriptPlayMode(transcript){
        return (this.playingRegionUid == transcript.uid)
    },
    playTranscript(transcript){
        this.playingRegionUid = transcript.uid;
        this.$emit('loadVideo', transcript)
    },
    highlightTranscript(transcriptText) {
        let searchValue = this.$parent.getglobalSearchedValue();
        searchValue = String(searchValue);
        if (!searchValue) return transcriptText;
        try{
            var keywordList = searchValue.match(/[^\s"]+|"[^"]+"/g).map(x => x.replace(/"/g, ''));
            keywordList.sort((a, b) => b.length - a.length);
            var filteredKeywordList = [];
            for(var i = 0; i < keywordList.length; i++){
              if(String(keywordList[i]).trim() != ''){ 
                  var eachKeyword = keywordList[i];
                  filteredKeywordList.push(eachKeyword+'\\w*');   
              }
            }
            var pattern = new RegExp(String.raw`(?<=[(["\s]|^)(${filteredKeywordList.join("|")})[^\]\s)"]*`, 'igm');
            var textDescription = transcriptText.replace(pattern, `<font color="OrangeRed">$&</font>`);
            return textDescription;
        }catch(e){
            console.log('error',e);
            return transcriptText;
        }
    },
    getDurationFormatAsHHorMMSS(duration){
       return Utils.getDurationInHHorMMSS(duration / 1000);
    },
    playSubclip(){
        this.$emit("playSubclip",this.subclipsData);
    },
    getCustomMetadataName(id){
      let customMetadataDetails = this.customMetadataList.filter(c=>c._id == id);
      if(customMetadataDetails.length > 0){
        return customMetadataDetails[0].name;
      }
      return "";
    },
    getPicklistValueNames(multiValueIds){
        if(multiValueIds != undefined && multiValueIds.length > 0){
            let valList =[];
            for(let valId of multiValueIds){
            let valDetails = this.fieldInfo.filter(op=>op.value_id == valId);
            if(valDetails.length > 0){
                valList.push(valDetails[0].value);
            }
            }
            return valList.join(", ");
        }
        return "None"
    },
    getDurationInSecondsForMarkers(duration){
        let regex = new RegExp(":")
        if(regex.test(duration)){
            return duration;
        }
        return Utils.getExactDuationInSeconds(duration/1000)
    },
    replaceByDefaultImage(e){
            e.target.onerror = null
            if(this.latestCapturedThumbnail && this.selectedAssetId && this.selectedAssetId == this.subclipsData.asset_id){
                e.target.src = this.latestCapturedThumbnail;
            }else{
                e.target.src = Utils.getNoThumbnailImg();
            }
        },
    handleSubclipsNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
            let subclip_info = notification.message;
            if(notification.message_type == NotifierConstants.assetModifiedNotification){
                if(this.subclipsData._id == subclip_info.asset_id){
                    this.subclipsData = subclip_info;
                }
            }
        }
    },
    handleProxyNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
            let subclip_info = notification.message;
            if(this.subclipsData._id == subclip_info.asset_id){
                if(Object.keys(subclip_info).includes('markers') && Object.keys(subclip_info.markers).length > 0){
                   this.$set(this.subclipsData,'markers',subclip_info.markers);
                }
                if(Object.keys(subclip_info).includes('proxy_info') && Object.keys(subclip_info.proxy_info).length > 0){
                   this.$set(this.subclipsData,'proxy_info',subclip_info.proxy_info);
                }
                this.thumbnail = Utils.convertToLoginIPDomainName(this.subclipsData.markers.frame_thumbnail_uri);
                this.componentKey++;
            }
        }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[NotifierConstants.assetModifiedNotification],
            callback:this.handleSubclipsNotification,
            parent:"subclipsInfo"})
      this.addWSEventListener({
            eventname:[NotifierConstants.fileModifiedNotification],
            callback:this.handleProxyNotification,
            parent:"subclipsInfo"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[NotifierConstants.assetModifiedNotification],
            callback:this.handleSubclipsNotification,
            parent:"subclipsInfo"})
      this.removeWSEventListener({
            eventname:[NotifierConstants.fileModifiedNotification],
            callback:this.handleProxyNotification,
            parent:"subclipsInfo"})
    },
    getThumbnailPath(file) {
      return Utils.getThumbnailPathfromFileInfo(file);
    },
    getHumanReadableDuration(duration){
      return Utils.getDurationInSeconds(duration)
    },
    humaniseSize(bytes){
        let data = Utils.humanizeSize(bytes)
        return `${data["value"]} ${data["unit"]}`
    },
    ...mapActions("assets", ["getAssetInfoFromServer"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"])
   },
   beforeDestroy(){
       this.unRegisterforWebsocketNotifications()
   },
   async created(){
       this.stylesFromParent = this.customStyles;
       if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
          this.customMetadataList = this.getStartUpDataFromInCache()["custom_metadatas"];
        }
        if(Object.keys(this.subclipsData).includes('field_info')){
            this.fieldInfo = this.subclipsData["field_info"];
          }
        this.registerforWebsocketNotifications();

   },
}
</script>

<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$background-color-on-hover: #141414;
$body-background-color: #141414;
$dull-text-color: #858585;
$options-text-color: #9c9c9c;
$icon-color-on-hover: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$table-border-color:1px solid #141414;
$active-blue: #007bff;
$danger-color: #dc3545 !important;
$input-field-bg-color: #121212;
$input-field-border-color: #202020;
$input-field-height:38px;
$button-height:38px;
$secondary-border-color: 1px solid #3a3a3a;
$searchBar-border-color: 1px solid #202020;
$secondary-text-color: #9c9c9c;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#141414;
$scrollbar-thumb-on-hover-background:#555;
$input-field-padding:.375rem 10px;
$input-field-and-label-font-size:14px;
$danger-color: #dc3545 !important;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$breadcrumb-background:#181818;
$mutliselect-tag-bg-color:#0a0a0a;
$mutliselect-all-tags-bg-color:#161616;
$multiselect-option-highlight-bg-color:#242424;
$multiselect-tag-on-focus-or-hover-bg-color:#3D3D3D;
$learn-about-text-color:#e8912d;
$close-icon-bg-on-hover:#3a3a3a;
$svg-color:#9e9e9e;
$tags-background-color:#272727;
$tags-border-color:#363636;
$multiselect-tag-border-color:#292929;
$metadata-border-color:#303030;
$metadata-border-color-on-hover: #5a5a5a;
$metadata-field-bg-color: #1d1d1d;
$primary-background: #1a1e21;

.slug-name{
    overflow-wrap:anywhere;
    font-size:20px;
    margin-top: -2px;
}

.selected-tags-style{
  background: $tags-background-color;
  border: 1px solid $tags-border-color;
  border-radius: 15px;
  font-size: 12px !important;
  min-height: 30px !important;
  display: inline-flex !important;
  margin: 2px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: center;
  width: auto !important;
  padding-inline-start: 8px !important;
  justify-content: center;
  padding-top: 4px !important;
  padding-inline-end: 8px !important;
  .remove-tag{
    line-height:18px;
  }
}

.subclip-thumbnail{
    width:180px;
    padding:5px;
    border-radius: 5px;
    cursor:pointer;
    border: 1px solid #4a4a4a;
    margin-bottom: 5px;
    img{
        object-fit: contain;
    }
}
.subclip-thumbnail:hover{
    .bi-play-circle-fill{
        fill:$close-icon-bg-on-hover;
    }
}
ul{
    list-style-type: none;
    padding: 0px;
    margin:0px;
    li{
        display:inline-flex;
        width: 100%;
        padding:3px;
        .key-style{
            color:$dull-text-color;
            width:16%;
            text-align: end;
            overflow-wrap: anywhere;
        }
        .value-style{
            color: #c7c7c7;
            text-align: start;
            margin-inline-start: 8px;
            overflow-wrap: anywhere;
        }
    }
}

.play-icon{
    position: absolute;
    top: 34%;
    width: 100%;
    fill: $close-icon-bg-on-hover;
    inset-inline-start: -2px;
    cursor: pointer;
}

.thumbnail-view-duration-label{
    font-size: 14px;
    background: #01868c;
    padding: 1px 5px;
    justify-content: start;
    display: flex;
    border-radius: 3px;
    color: #000 !important;
    div{
        color: #eee !important;
    }
  }

  .custom-metadata-rows{
    padding:2px;
  }
  .transcript-wrapper{
    margin-top: 12px;
    margin-bottom: 3px;
    display: inline-grid;
    float:inline-start;
    .each-transcript{
        border: none !important;
        border-bottom: 1px solid #242424 !important;
        border-radius: 0 !important;
    }
    li:last-child{
        border-bottom: 0 !important;
    }
    .transcript-preview {
        :hover .transcript-play-pause{
            // visibility: visible;
            svg{
                fill:#eee !important;
            }
        }
        .transcript-content{
            display: flex;
            align-items: flex-start;
            text-align: start;
        }
        .transcript-play.transcript-timestamp{
            display: flex;
            align-items: center;
        }
        .transcript-spoken-content{
            margin-inline-start: 6px;
            text-align: start;
            user-select: text;
            cursor: auto;
        }
        .transcript-play-pause{
            //  visibility: hidden;
            svg{
            fill:#5e5e5e !important;
            }
        }

        .common-media-in-out-display{
            font-size: 14px;
            background: rgb(52, 52, 52);
            padding: 2px 5px; 
            justify-content: start; 
            display: flex; 
            border-radius: 3px;
            color: rgb(238, 238, 238) !important;
            gap:3px;
        }
    }
  }

  .no-data-found{
    color: $secondary-text-color;
    margin:0px 10px 5px 10px;
 }
 .actions-on-transcript{
    margin:10px 0px;
    cursor: pointer;
    svg{
        padding: 6px;
        height: 28px;
        width: 28px;
        border-radius: 4px;
    }
    svg:hover{
        background: #d1d2d31a;
    }
    .transcript-edit{
        visibility:hidden
    }
 }
 .transcript-wrapper:hover{
  .transcript-edit{
    visibility: visible;
  }
}

.wrap-file-info{
    border: 1px solid #384445;
    border-radius: 10px;
    background: #202729 !important;
    margin: 10px 5px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    margin-top: 0px;
  }

  .sub-thumbnail-view-duration-label{
    color: #eee !important;
    position: absolute; 
    bottom: 0px;
    inset-inline-start:0px;
    font-size: 10px;
    background: #01868c;
    padding: 1px 5px;
    justify-content: center;
    display: flex;
    border-radius: 3px;
  }

  .adjust-alignments{
    font-size:14px;
    .wrap-file-info{
        width:98% !important;
    }
    .key-style{
        text-align: start !important;
        width:40% !important;
    }
    .value-style{
        width:100% !important;
    }
  }
  .notification-filters{
    border: 1px solid rgb(54, 54, 54);
    border-radius: 15px;
    padding: 14px;
    display: flex;
    align-items: center;
    margin-inline-end: 5px;
    height: 30px;
    color: #c7c7c7;
    width: 130px;
    margin-inline-start: 8px;
    background:rgb(40, 45, 49)
  }

  .metadataViewCustomStyles{
    border: 1px solid var(--line);
    background: rgba(255, 255, 255, .02);
    border-radius: 16px;
    overflow: hidden;
    width:100%;
    .thumbnail-view-duration-label{
        margin-inline-start: 0px !important;
    }
    .subclip-top-bar{
        display: flex;
        gap: 12px;
        padding: 12px !important;
        border-bottom: 1px solid rgba(255, 255, 255, .06);
        background: linear-gradient(180deg, rgba(255, 255, 255, .02), rgba(255, 255, 255, 0));
        align-items: stretch;
        .subclip-thumbnail{
            width: 140px;
            height: 78px;
            border-radius: 12px;
            border: 1px solid rgba(255, 255, 255, .10);
            overflow: hidden;
            background: radial-gradient(140px 90px at 30% 30%, rgba(59, 130, 246, .20), rgba(0, 0, 0, .12)), linear-gradient(135deg, rgba(45, 212, 255, .18), rgba(255, 255, 255, .03));
            position: relative;
            flex: 0 0 auto;  
            .playOverlay{
                position:absolute;inset:0;
                display:grid;place-items:center;
                background:linear-gradient(180deg, rgba(0,0,0,.10), rgba(0,0,0,.25));
            }
            .playOverlay .pbtn{
                width:42px;height:32px;border-radius:10px;
                display:grid;place-items:center;
                border:1px solid rgba(255,255,255,.18);
                background:rgba(10,16,24,.55);
            }
        }
    }
    .slug-name{
        font-size: 18px;
        font-weight: 800;
        letter-spacing: .1px;
        margin-top: 2px;
    }
    .description-field{
        color: rgba(255, 255, 255, .78);
        font-size: 14px;
        line-height: 1.45;
    }
    .catalog-path-display{
        color: rgba(255, 151, 151, .85);
        font-weight: 700;
        font-size: 13px;
    }
    .timePill-subclip{
        display: inline-flex;
        align-items: center;
        gap: 8px;
        width: max-content;
        padding: 6px 10px;
        border-radius: 10px;
        border: 1px solid rgba(45, 212, 255, .20);
        background: rgba(45, 212, 255, .10);
        color: rgba(255, 255, 255, .92);
        font-weight: 800;
        letter-spacing: .3px;
        font-variant-numeric: tabular-nums;
    }
  }
</style>